<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="01" :question="question"></QuestionTitle>
        <div class="container-70">
            <NbCalculator :img="peopleImg" :listOfInputs="listOfInputs" v-model="result"></NbCalculator>
            <div v-if="result!=null" @click="saveAndContinue('citoyenNbPerson', JSON.stringify(result), './question-2')" class="btn-primary d-block w-100 mt-50px text-center" >Suivant</div>
            <AvancementLine percent="33%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import NbCalculator from '@/components/NbCalculator.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'De combien de personnes mon ménage est composé? ',
            peopleImg:require('@/assets/images/family.png'),
            listOfInputs:[
                {label:'Adultes', description:'16 ans et plus'},
            ]
        }
    },
    components: {
        QuestionTitle,
        NbCalculator,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('citoyenNbPerson')){
            this.result=JSON.parse(sessionStorage.getItem('citoyenNbPerson'))
        }
    }
}
</script>